export const tooltip = {
  root: {
    maxWidth: "175px",
    gutter: "4px",
    shadow: "{overlay.popover.shadow}",
    padding: "{padding.8} {padding.12}",
    borderRadius: "{overlay.popover.border.radius}",
    background: "{plain.default}",
    color: "{surface.bg-white}",
  },
  extend: {
    ui: {
      fontSize: "{typography.body.text.regular.font.size}",
      fontLeading: "{typography.body.text.regular.font.leading}",
    },
  },
  css: ({ dt }: any): string => `
    .p-tooltip-text {
      font-size: ${dt("tooltip.ui.font.size")};
      line-height: ${dt("tooltip.ui.font.leading")};
    }
  `,
};
